import * as React from "react";
import LiquorImg from "./liquor-img";
import MadeInAlberta from "./made-in-alberta";
export default class LiquorItem extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let sponsored = this.props.sponsored ?
            React.createElement("div", { className: "liq-sponsor" },
                React.createElement("div", { className: "liq-sponsor-text" }, "SPONSORED"),
                React.createElement("div", { className: "liq-sponsor-triangle" })) : null;
        let cityCheck = this.props.city || "";
        let typeCheck = this.props.liqType || "";
        let city = cityCheck.trim().length > 1 ? `| ${this.props.city}` : null;
        let liqType = typeCheck.trim().length > 1 ? `| ${this.props.liqType}` : null;
        let sizeNumber = parseFloat(this.props.size);
        let sizeText = !isNaN(sizeNumber) ? `${sizeNumber}ml` : '';
        if (!isNaN(sizeNumber) && this.props.singlesPerUnit < 2 && sizeNumber >= 1000) {
            sizeText = `${sizeNumber / 1000}L`;
        }
        else if (!isNaN(sizeNumber) && sizeNumber > 0 && this.props.singlesPerUnit > 1) {
            let sizePerUnit = sizeNumber / this.props.singlesPerUnit;
            sizeText = `${sizePerUnit}ml x ${this.props.singlesPerUnit}`;
        }
        return (React.createElement("a", { className: "liquor-item " + (this.props.sponsored ? 'premium' : ''), href: `/Products/Item/${this.props.id}` },
            React.createElement("div", { className: "liquor-item-wrapper" },
                React.createElement(MadeInAlberta, { madeInAlberta: this.props.madeInAlberta }),
                React.createElement("div", { className: "liquor-img" },
                    React.createElement(LiquorImg, { src: this.props.imgPath }),
                    sponsored),
                React.createElement("div", { className: "liquor-caption" },
                    React.createElement("h2", null, this.props.title.toLowerCase()),
                    React.createElement("p", { className: "liquor-subtitle" },
                        this.props.category,
                        " ",
                        liqType),
                    React.createElement("p", { className: "liquor-subtitle" },
                        this.props.country,
                        " ",
                        city),
                    sizeText && React.createElement("p", { className: "liquor-subtitle" }, sizeText)))));
    }
}
;
//# sourceMappingURL=liquor-item.js.map